var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 40 } },
        _vm._l(_vm.mvmPanel, function (item) {
          return _c(
            "el-col",
            {
              key: item.title,
              staticClass: "card-panel-col",
              attrs: { xs: 12, sm: 12, md: 6 },
            },
            [
              _c("div", [
                _c("div", { staticClass: "card-panel" }, [
                  _c(
                    "div",
                    { staticClass: "card-panel-icon-wrapper icon-people" },
                    [
                      _c("i", {
                        staticClass: "el-icon-loading card-panel-icon",
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "card-panel-description" },
                    [
                      _c("div", { staticClass: "card-panel-text" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _c("count-to", {
                        staticClass: "card-panel-num",
                        attrs: {
                          "start-val": 0,
                          "end-val": item.value,
                          duration: 2600,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }